import {
  Drawer,
  DrawerContent,
  useMediaQuery,
  useColorModeValue,
  useTheme,
  Button,
} from "@chakra-ui/react";
import React, { useContext, useEffect } from "react";
import { AppContext } from "../context/app.context";
import { MapContext } from "../context/map.context";
import BottomSheetWrapper from "./BottomSheetWrapper";
import FavouriteButton from "./FavouriteButton";

type Props = {
  children: React.ReactNode;
  ml?: string
  maxDrawerHeight?: number
};

const HybridBottomSheetDrawer = ({ children, ml, maxDrawerHeight }: Props) => {
  const [desktop] = useMediaQuery("(min-width: 1100px)");
  const { setOffset } = useContext(MapContext);
  const theme = useTheme();
  const drawerBg = useColorModeValue("white", theme.colors?.["gray"]?.["900"]);

  useEffect(() => {
    if (desktop) {
      setOffset([220, 0]);
      return () => setOffset([0, 0]);
    }
  }, [desktop, setOffset]);

  return desktop ? (
    <Drawer
      size="sm"
      isOpen={true}
      onClose={() => null}
      trapFocus={false}
      placement="left"
      variant="alwaysOpen"
    >
      <DrawerContent
        overflow="hidden"
        position="relative"
        bg={drawerBg}
        m={10}
        ml={ml ? ml : 10}
        rounded="xl"
        overflowY="auto"
      >
        {children}
      </DrawerContent>
    </Drawer>
  ) : (
    <BottomSheetWrapper maxHeight={maxDrawerHeight ? maxDrawerHeight : window.innerHeight}>{children}</BottomSheetWrapper>
  );
};

export default HybridBottomSheetDrawer;
